<template>
  <div class="sm-empty-table-comp">
     <include-svg :name="icon" />
     <h5 v-if="title.length">{{title}}</h5>
     <p v-if="text">{{text}}</p>
  </div>
</template>

<script>
export default {
  name: 'empty-table',
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .sm-empty-table-comp {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 247px;
    margin: 0 auto;
    padding: 180px 0 60px;
    text-align: center;

    & > svg {
      margin: 0 auto;
    }

    & > h5 {
      margin: 8px 0 13px;
    }
  }
</style>